import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { LogService } from './logging.service';
import { HashDao, HasherDao } from '../daos';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';

const CLASS_NAME = 'HasherService';

@Injectable()
export class HasherService {

  constructor(private _log: LogService, private hasherDao: HasherDao, private _hashDao: HashDao) {
  }

  public get(confirmationNumber: string, firstName: string, lastName: string, checkInDate: string, checkOutDate: string, hotelCode: string): Observable<string> {
    return this.hasherDao.get(confirmationNumber, firstName, lastName, checkInDate, checkOutDate, hotelCode)
      .map((data) => {
        return !!data ? data.hash : '';
      })
      .catch((error) => {
        this._log.error(`Error getting hasher ${confirmationNumber} - ${lastName} - ${checkOutDate}`, CLASS_NAME, error);
        return Observable.throw(error);
      });
  }

  public getHashByStayId(stayId: string): Observable<string> {
    return this._hashDao.getHash(stayId).pipe(
      map((data: any) => {
        return !!data && !!data.hash ? data.hash : '';
      }),
      catchError((error) => {
        this._log.error(`Error getting hasher by StayId`, CLASS_NAME, error);
        return Observable.throw(error);
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/hasher.service.ts